import { render, staticRenderFns } from "./zoning-change-index.vue?vue&type=template&id=2021a1cc"
import script from "./zoning-change-index.vue?vue&type=script&lang=js"
export * from "./zoning-change-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports